import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { AuthService, ConfigStateService } from '@abp/ng.core';
import { CUSTOM_HTTP_ERROR_HANDLER_PRIORITY, CustomHttpErrorHandlerService } from '@abp/ng.theme.shared';

import { NexRefreshAuthTokenService } from './nex-refresh-auth-token.service';

@Injectable({
  providedIn: 'root',
})
export class NexAbpAuthenticationErrorHandler implements CustomHttpErrorHandlerService {
  readonly priority = CUSTOM_HTTP_ERROR_HANDLER_PRIORITY.veryHigh;
  protected readonly authService = inject(AuthService);
  protected readonly configStateService = inject(ConfigStateService);
  protected readonly refreshAuthService = inject(NexRefreshAuthTokenService);

  canHandle(error: unknown): boolean {
    return error instanceof HttpErrorResponse && error.status === 401;
  }

  execute() {
    // Pipe in the refresh service result to delay checking the app state until the refresh completes (successfully or not)
    this.refreshAuthService.ensureValidAccessToken$().subscribe(() => {
      this.configStateService.refreshAppState().subscribe(({ currentUser }) => {
        if (!currentUser?.isAuthenticated) {
          this.authService.logout({ noRedirectToLogoutUrl: true });
        }
      });
    });
  }
}
